import { rouletteNumbersArrangement, perNumberAngle } from './constants';

export const lerp = (start, end, t) => {
  t = Math.min(1, Math.max(0, t));
  return start + t * (end - start);
};

export const degreesToRadians = (degrees) => degrees * (Math.PI / 180);

export const transformTo0360 = (num) => (num + 360) % 360;

export const createCircle = ({ x, y, z, radius1, radius2 = radius1 }) => {
  return {
    x,
    y,
    z,
    radius1,
    radius2,
    radius: radius1,
    getPointCoordinates(angle) {
      angle += Math.PI / 2;
      const xCoord = this.x + this.radius * Math.cos(-angle);
      const zCoord = this.z + this.radius * Math.sin(-angle);
      return { x: xCoord, y: this.y, z: zCoord };
    },

    setPosition(x, y, z) {
      /* eslint-disable */
      this.x = x;
      this.y = y;
      this.z = z;
    },

    setRadius(radius) {
      this.radius = radius;
    },

    interpolateRadius(alpha) {
      this.radius = radius2 * alpha + radius1 * (1 - alpha);
      return this.radius;
    },

    initialize() {
      this.setRadius(radius1);
      this.setPosition(x, y, z);
    },
  };
};

export const getRouletteNumberIndex = (n) =>
    rouletteNumbersArrangement.findIndex((number) => number === n);

export const getNumberAngle = (n) => getRouletteNumberIndex(n) * perNumberAngle;

export const getRandomRouletteNumber = () =>
    rouletteNumbersArrangement[Math.floor(rouletteNumbersArrangement.length * Math.random())];

export const sha256 = async (message) => {
  // encode as UTF-8
  const msgBuffer = new TextEncoder().encode(message);

  // hash the message
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

  // convert ArrayBuffer to Array
  const hashArray = Array.from(new Uint8Array(hashBuffer));

  // convert bytes to hex string //hashHex
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
};

export const generateRandomNumber = async (number) => {
  const sha = await sha256(number);
  const a = sha.slice(0, 13);
  return parseInt(a, 16) / 2 ** 52;
};

export const lookAtFollower = (obj1, obj2) => {
  requestAnimationFrame(() => lookAtFollower(obj1, obj2));
  obj1.lookAt(obj2.position);
};

export const getRandomItem = (arr) => {
  const randomIndex = Math.floor(Math.random() * arr.length);
  return arr[randomIndex];
};

export const setDevMoveForThreeJsCanvas = () => {
  document.getElementsByClassName('roulette-game-inner')[0].style.display = 'none';
  document.getElementById('roulette-canvas').style.pointerEvents = 'auto';
};

export const getRandomNumberInRange = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
